.phoneText {
  text-decoration: none;
  color: #1976d2;
  font-weight: 500;
}

.phoneMenu {
  left: 50px !important;
  top: 48px !important;
}
